import dayjs, { Dayjs } from 'dayjs';
export const formatDateRange = (dates: [Dayjs, Dayjs]) => {
  if (dates && dates.length === 2 && dates[0] && dates[1]) {
    const date1 = dayjs(dates[0]);
    const date2 = dayjs(dates[1]);

    if (date1.year() === date2.year()) {
      // Если года одинаковые
      if (date1.month() === date2.month()) {
        // Если месяцы одинаковые
        return `${date1.format('MMMM D, HH:mm')} - ${date2.format('D, HH:mm')}`;
      } else {
        // Если месяцы разные
        return `${date1.format('MMMM D, HH:mm')} - ${date2.format('MMMM D, HH:mm')}`;
      }
    } else {
      // Если года разные
      return `${date1.format('MMMM D, YYYY, HH:mm')} - ${date2.format('MMMM D, YYYY, HH:mm')}`;
    }
  }
  return 'Неверный диапазон дат';
};
